import React from 'react';
import DayPicker from 'react-day-picker/DayPicker';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocalUtils from 'react-day-picker/moment';
import {DateUtils} from "react-day-picker";

import {translate} from 'iss/strings';
import dates from 'iss/utils/dates';
import {toggleValueInList} from 'iss/utils/functional';
import {FlexRow} from 'iss/widgets/Flex';
import {FormSection} from 'iss/widgets/Forms';
import BootstrapFormGroup from 'iss/widgets/bootstrap/FormGroup';
import {formComponent} from 'iss/widgets/form/Field';
import {TaggingInput} from 'iss/widgets/form/input/TaggingInput';

require('react-day-picker/lib/style.css');

export const DatePicker = formComponent(({id, value, onChange, ...props}) => {
  return <BootstrapFormGroup id={id} {...props}>
    <DayPickerInput value={value} onDayChange={onChange}
      inputProps={{
        className:"form-control", id
      }}
      formatDate={dates.format}
      parseDate={dates.parse}
      placeholder={dates.format(new Date())}
      dayPickerProps={{ localeUtils: MomentLocalUtils, locale: "fi", ...props }} />
  </BootstrapFormGroup>;
});

export function DateRangePicker({valuePath, toLabel, fromLabel, id, validateTo, validateFrom}) {
  return <FormSection valuePath={valuePath}>
    {(values, formApi) =>
      <FlexRow id={id} flexAllChildren>
        <DatePicker flex="none" label={fromLabel} id={id+"-from"} valuePath="from" validate={validateFrom}
          onChange={(fromDate) => {
            if (values && values.to && DateUtils.isDayAfter(fromDate, values.to)) formApi.setValue("to", fromDate);
          }}
        />
        <DatePicker flex="none" label={toLabel} id={id+"-to"} valuePath="to" validate={validateTo} disabledDays={day => values && values.from && DateUtils.isDayBefore(day, values.from)} />
      </FlexRow>
    }
  </FormSection>;
}

export const MultiDateChooser = formComponent(({value, onChange, ...props}) => {
  const selectedDates = value || [];
  return <FlexRow flexAllChildren>
    <BootstrapFormGroup {...props}>
      <TaggingInput id={props.id} parseTag={dates.parse} formatTag={dates.format}
        placeholder={translate('widgets.multiDateInput.writeDateHereOrChooseFromCalendar')}
        tags={selectedDates} onChange={onChange} />
    </BootstrapFormGroup>
    <DayPicker flex="none"
      onDayClick={day => {
        onChange(toggleValueInList(day)(selectedDates));
      }}
      selectedDays={selectedDates}
      localeUtils={MomentLocalUtils} locale="fi"
    />
  </FlexRow>;
});




// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/form/input/DateInputs.jsx